<template>
  <div class="voip-selection" :class="{ answered: Boolean(selectedOption) }">
    <div
      v-for="option of options"
      :key="option.id"
      class="voip-option"
      :class="{ selected: isSelected(option), [option.id]: true }"
      @click="select(option)"
    >
      <img
        v-if="isSelected(option)"
        :src="option.iconSelected.src"
        :alt="option.iconSelected.alt"
        class="option-icon"
        :class="option.id"
      >
      <img
        v-else
        :src="option.icon.src"
        :alt="option.icon.alt"
        class="option-icon"
        :class="option.id"
      >

      <span class="option-label">{{ option.label }}</span>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual'
import Utag from '@/mixins/Utag'

export default {
  name: 'VOIPSelection',
  mixins: [Utag],
  props: {
    value: {
      // Answer
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      default: () => ({
        voip: 'use-voip.svg',
        voipSelected: 'use-voip.svg',
        noVoip: 'no-voip.svg',
        noVoipSelected: 'no-voip.svg'
      })
    }
  },
  data () {
    return {
      options: [
        {
          id: 'voip',
          label: 'I already use VoIP',
          value: 'Existing',
          vuClass: 'voip-option_voip',
          vuId: 'voip-user-existing',
          name: 'existing-user-already-use',
          icon: {
            src: require(`@/assets/icons/${this.icons.voip}`),
            alt: 'Voip icon'
          },
          iconSelected: {
            src: require(`@/assets/icons/${this.icons.voipSelected}`),
            alt: 'Voip icon'
          }
        },
        {
          id: 'no-voip',
          label: "I'm new to VoIP",
          value: 'New',
          vuClass: 'voip-option_no-voip',
          vuId: 'voip-user-new',
          name: 'existing-user-dont-use',
          icon: {
            src: require(`@/assets/icons/${this.icons.noVoip}`),
            alt: 'No-voip icon'
          },
          iconSelected: {
            src: require(`@/assets/icons/${this.icons.noVoipSelected}`),
            alt: 'No-voip icon'
          }
        }
      ]
    }
  },
  computed: {
    selectedOption () {
      if (!this.value) return {}

      return this.options.find((option) =>
        isEqual(option.value, this.value.result)
      )
    }
  },
  methods: {
    select (option) {
      this.voipUser(option.vuClass, option.vuId, option.name, option.label)
      this.$emit('input', { result: option.value })
    },
    isSelected (option) {
      return this.selectedOption && this.selectedOption.id === option.id
    }
  }
}
</script>

<style scoped lang="scss">
.voip-selection {
  display: flex;
  justify-content: space-between;

  @media (max-width: $screen-md) {
    flex-direction: column;
  }

  &.answered .voip-option {
    * {
      opacity: 0.6;
    }

    &.selected * {
      opacity: 1;
    }
  }

  .voip-option {
    background-color: $white;
    box-shadow: $voip-shadow;
    border-radius: $voip-border-radius;
    width: calc(33% - 15px);
    text-align: center;
    position: relative;
    padding: $spacing-20;
    cursor: pointer;
    transition: 0.25s all;
    border: $voip-border;
    height: $voip-height;
    top: 0;

    @media (max-width: $screen-md) {
      width: 100%;
      margin-bottom: $spacing-16;
      display: flex;
      height: $voip-height-mobile;
      align-items: center;
      padding: $spacing-8;

      &:last-child {
        margin-bottom: 0;
      }
    }

    @media(min-width: 800px) {
      width: calc(50% - 30px);
      padding: $spacing-30;
      height: 166px;
    }

    &:hover {
      box-shadow: 0 2px 11px 0 rgba(30,45,114,0.1);;
      top: -4px;
    }

    .option-icon {
      height: $voip-icon-height;
      display: inline-block;
      margin-bottom: $voip-margin-bottom;
      margin-top: $voip-margin-top;

      @media (max-width: $screen-md) {
        max-width: $spacing-36;
        max-height: $spacing-36;
        margin-right: $spacing-12;
        margin-top: $voip-icon-margin-top-mobile;
      }
    }

    .option-label {
      line-height: 22px;
      display: flex;
      width: 100%;
      text-align: center;
      justify-content: center;

      @media (max-width: $screen-lg) and (min-width: $screen-md + 1) {
        align-items: center;
        justify-content: center;
        height: $spacing-40;
      }

      @media (max-width: $screen-md) {
        justify-content: flex-start;
      }
    }

    &.selected {
      border: $voip-selected-border;
      box-shadow: $voip-shadow-selected;
      background-color: $voip-selected-bg;
      color: $voip-selected-text;
    }
  }
}
</style>
